export default thematics => thematics.map(thematic => thematic.label);
